(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('reportsPrerequisiteService', ReportsPrerequisiteService);

    ReportsPrerequisiteService.$inject = ['$q', 'userPermissions', 'brandServices', 'hUser', 'TeamScheduleService', 'userServices'];

    function ReportsPrerequisiteService($q, userPermissions, brandServices, hUser, TeamScheduleService, userServices) {
        var self = this;

        var isClockTimeAppEnabled = TeamScheduleService.isClockTimeAppEnabled;
        var activeReportsSettings = {};
        var activeReports = {};
        var teamLiveGroupSettings = {};
        const scheduleSettings = {};
        var wendysLaborSettings = {};
        var ABSSettings = {};
        var carrolLaborSettings = {};
        var isGFEScheduleOnAnyChild = {};
        var postHireServiceSettings = {};
        var hasOtherAbsenceTypesCached = {};
        var isReportsMenuVisible = {};
        var isEmployerAndEnterOrChildHasHarriClockOrPOS = {};
        var hasManageWagesAccess = {};
        var isCustomReportsServiceEnabled = {};
        var hasSalesAccess = {};
        var canViewBiometricConsentReport = {};
        const canViewBreakWaiverConsentReport = {};
        var isHarriClockEnabled = {};
        var isTeamSchedulingEnabled = {};
        var isBiometricConsentReportSettingsEnabled = {};
        const isBreakWaiverConsentReportSettingsEnabled = {};
        var canViewAttendanceReliabilityReport = {};
        const canViewUnemploymentClaimsReport = {};
        var canViewAvailabilityReport = {};
        var canViewEmployeeRosterReport = {};
        var isAbsenceTrackerReportVisible = {};
        var isSatisfactionEnabled = {};
        var canViewEmployeesSatisfaction = {};
        var isAllowedToViewEmployeesPunchPhoto = {};
        var clockLoginSettings = {};
        var hasAnyAbsenceTrackerAccess = {};
        var canAccessEditsReport = {};
        var isTeamQuestionnaireServiceEnabled = {};
        var canViewEmployeeQuestionnaireReports = {};
        var hasManageAbsenceRequestsPermission = {};
        var canViewDailyActivityReport = {};
        var canViewLaborAnalysisReport = {};
        var canViewTimePunchSummaryReport = {};
        var canViewFullPunchDetailReport = {};
        var canViewTimePunchChangeApprovalReport = {};
        var canViewLaborExceptionReport = {};
        var canViewPayPeriodReport = {};
        var canViewForecastAccuracyReport = {};
        var canViewDailyCrewScheduleLineBarReport = {};
        var canViewScheduleChangeReport = {};
        var canViewWeeklyScheduleReport = {};
        var isAllowedAccessTimeSheet = {};
        var isAllowedAccessToAll = {};
        var isFailScheduleEnabled = {};
        var canManageEmployeeTimeCards = {};
        var canManageHourlyEmployessWages = {};
        var hasAnyWagesAccess = {};
        var hasActiveBrandHarriClock = {};
        var hasActiveBrandPOS = {};
        var isUKBrand = {};
        var isDKBrand = {};
        var isGFEServiceEnabled = {};
        var isOnboardingJourneyEnabled = {};
        let isHarriEngageEnabled = {};
        let anonymityMode = {};
        let surveysEnabled = {};
        let hasViewTeamEngagement = {};
        let isTLAccessOnlyUser = false;
        var canViewEmployeeEngagement = {};
        var canAccessEmployeeTurnoverReport = {};
        var isLogbookEnabled = {};
        var canManageLogbookEntries = {};
        var canViewLogbookEntries = {};
        var isWendysLaborServiceEnabled = {};
        var isWendysSettingsEnabled = {};
        var isABSServiceEnabled = {};
        var isABSSettingsEnabled = {};
        const canViewManagerSchedule = {};
        const isStationsLevelsEnabled = {};
        const isScheduleManagerViewAvailable = {};
        var isCarrolLaborServiceEnabled = {};
        var isCarrolSettingsEnabled = {};
        var hasManageOrPublishSchedulePermissions = {};
        var isActiveBrandEnterprise = {};
        var canAccessUnscheduledEmployeeReport = {};
        var isConsiderRegularScheduleVariationSettingsEnabled = {};
        const canViewMcHireIntegrationRejectionReport = {};
        const canViewFredIntegrationRejectionReport = {};
        var isVariationSettingEnabledOnOneOrMoreChild = {};
        const isMcHireCreationFlowEnabled = {};
        const isSkillLevelSyncEnabled = {};
        var isDataPassSyncEnabled = {};
        var canAccessFlashWageTypeSummaryReport = {};
        var canViewScheduleCreationMetricReport = {};
        var canViewNoPayReport = {};
        var canViewAdpEmployeeSyncReport = {};
        var announcementsSettings = {};
        let gfeTemplateSettingsCache = {};
        let timesheetSettingsCache = {};
        var isEmployer = hUser.isEmployer();
        var appliedPermissionsForPayTypes = [];
        var appliedViewPermissionsForPayTypes = [];
        var absenceTrackerReportPermissions = [
            userPermissions.PERMISSIONS.MANAGE_ABSENCE_REQUESTS,
            userPermissions.PERMISSIONS.MANAGE_TIMEOFF_REQUESTS,
            userPermissions.PERMISSIONS.MANAGE_SICKNESS_REQUESTS,
            userPermissions.PERMISSIONS.CREATE_UPDATE_LEAVE_OF_ABSENCE,
        ];
        var wagesPermissions = [
            userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES,
            userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES,
            userPermissions.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_WAGES,
            userPermissions.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES,
            userPermissions.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES,
            userPermissions.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES
        ];

        self.iniReportsPrerequisite = function (activeBrand) {
            var defer = $q.defer();
            var brandId = activeBrand.id;
            isUKBrand[brandId] = activeBrand.team_live_country_code === "UK";
            isDKBrand[brandId] = activeBrand.team_live_country_code === "DK";
            isActiveBrandEnterprise[brandId] = activeBrand && activeBrand.type === 'ENTERPRISE';
            hasActiveBrandHarriClock[brandId] = activeBrand.services && activeBrand.services.indexOf('HARRI_CLOCK') > -1;
            hasActiveBrandPOS[brandId] = activeBrand && activeBrand.services && activeBrand.services.indexOf('POS') > -1;
            anonymityMode[brandId] = activeBrand.engagement_anonymity_mode;

            if (hUser.isEmployer()) {
                appliedPermissionsForPayTypes = TeamScheduleService.getBrandPayTypePermissions(activeBrand);
                appliedViewPermissionsForPayTypes = TeamScheduleService.getBrandPayTypePermissions(activeBrand, true);
                hasSalesAccess = hUser.hasSalesAccess();
            }
            $q.all([
                userPermissions.getBrandPolicy(brandId),
                TeamScheduleService.getBrands(),
                self.getAttendanceReliabilityPrerequisites(brandId),
                self.getConsentPrerequisites(brandId),
                self.getUnemploymentClaimsReportPrerequisites(brandId),
                self.getAvailabilityReportPrerequisites(brandId),
                self.getEmployeeRostertPrerequisites(brandId),
                self.getAbsenceTrackerPrerequisites(brandId),
                self.getClockInMessagePrerequisites(brandId),
                self.getEmployeeEditsReportPrerequisites(brandId),
                self.getEmployeeHealthCheckReportPrerequisites(brandId),
                self.getGFEDocumentTrackingPrerequisites(brandId),
                self.getHealthCheckSummaryReportPrerequisites(brandId),
                self.getHolidayAllowanceReportPrerequisites(brandId),
                self.getTeamMemberMasterReportPrerequisites(brandId),
                self.getDARPrerequisites(brandId),
                self.getPayPeriodReportPrerequisites(brandId),
                self.getLaborAnalysisReportPrerequisites(brandId),
                self.getPunchReportsPrerequisites(brandId),
                self.getLaborExceptionReportPrerequisites(brandId),
                self.getApproachingWeeklyOTReportPrerequisites(brandId),
                self.getBreaksReportPrerequisites(brandId),
                self.getFWWPremiumsReportPrerequisites(brandId),
                self.getMissedBreaksReportPrerequisites(brandId),
                self.getForecastAccuracyReportPrerequisites(brandId),
                self.getPunchDetailReportPrerequisites(brandId),
                self.getTimeCardEditsReportPrerequisites(brandId),
                self.getEngagementSurveysReportPrerequisites(brandId),
                self.getTimeSheetReportPrerequisites(brandId),
                self.getPollEventsReportPrerequisites(brandId),
                self.getTurnoverReportPrerequisites(brandId),
                self.getWageTypeSummaryReportPrerequisites(brandId),
                self.getDailyCrewScheduleReportPrerequisites(brandId),
                self.getScheduleChangeReportPrerequisites(brandId),
                self.getWeeklyScheduleReportPrerequisites(brandId),
                self.getAvailableShiftsReportPrerequisites(brandId),
                self.getDetailedEmployeeLaborReportPrerequisites(brandId),
                self.getEmployeeLaborVarianceReportPrerequisites(brandId),
                self.getEnterpriseFlashReportPrerequisites(brandId),
                self.getFlashReportV2Prerequisites(brandId),
                self.getLaborVarianceReportPrerequisites(brandId),
                self.getLogbookChecklistsReportPrerequisites(brandId),
                self.getLogbookEntriesReportPrerequisites(brandId),
                self.getLogbookTasksReportPrerequisites(brandId),
                self.getManagerScheduleReportPrerequisites(brandId),
                self.getNeededHoursReportPrerequisites(brandId),
                self.getScheduleAuditReportPrerequisites(brandId),
                self.getScheduleStatusReportPrerequisites(brandId),
                self.getUnscheduledEmployeeReportPrerequisites(brandId),
                self.getMetricsReportPrerequisites(brandId),
                self.getRegularScheduleVariationsReportPrerequisites(brandId),
                self.getIntegrationRejectionReportsPrerequisites(brandId),
                self.getNoPayReportPrerequisites(brandId),
                self.getOnboardingJourneyEventsReportPrerequisites(brandId),
                self.getAdpEmployeeSyncReportPrerequisites(brandId),
                getHarriEngageReportsPrerequisites(brandId),
                self.checkJibLaborService(brandId),
            ]).then(function (res) {
                defer.resolve(res);
                var policyParser = res[0];
                hasManageWagesAccess = policyParser.has(userPermissions.PERMISSIONS.MANAGE_TEAM_LIVE_ADMINS) && policyParser.hasAny(wagesPermissions);
                isTLAccessOnlyUser = !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) && policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                var brands = res[1];
                var childrenHaveLPM_ClOCK = getChildrenHaveLPM_ClOCK(brands);
                initShowReport(activeBrand, childrenHaveLPM_ClOCK);
                isReportsMenuVisible[brandId] = Boolean(self.getFirstAvailableReportRoute(brandId));
            }).catch(function (err) {
                defer.reject(err);
            });
            return defer.promise;
            // call all reports preRequsite functions
        };

        self.checkReportsMenuVisibility = function (brandId) {
            return isReportsMenuVisible[brandId];
        };

        self.getFirstAvailableReportRoute = function (brandId) {
            var reportsChecks = [...hrReportsChecks, ...integrationReports, ...onboardingReports, ...schedulingReports, ...timeKeepingReports];
            for (var i = 0; i < reportsChecks.length; i++) {
                if (reportsChecks[i].check(brandId)) {
                    return reportsChecks[i].path;
                }
            }
            return false;
        };

        self.getAttendanceReliabilityPrerequisites = function (brandId) {
            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewAttendanceReliabilityReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_ATTENDANCE_RELIABILITY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkAttendanceReliabilityVisibility = function (brandId) {
            return (
                canViewAttendanceReliabilityReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['ATTENDANCE_RELIABILITY']
            );
        }

        self.getConsentPrerequisites = function (brandId) {
            const promises = {};

            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['activeReports'] = getActiveReports(brandId);
            promises['isHarriClockEnabled'] = brandServices.check(brandServices.SERVICES.HARRI_CLOCK, brandId, true);
            promises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId, true);
            promises['teamLiveGroupSettings'] = getTeamLiveGroupSettings(brandId);

            return $q.all(promises)
                .then(function (res) {
                    const policyParser = res['policyParser'];

                    canViewBiometricConsentReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_BIOMETRIC_CONSENT_REPORT);
                    canViewBreakWaiverConsentReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.ACCESS_BREAK_WAIVER_CONSENT_REPORT);
                    isHarriClockEnabled[brandId] = res['isHarriClockEnabled'];
                    isTeamSchedulingEnabled[brandId] = res['isTeamSchedulingEnabled'];
                    isBiometricConsentReportSettingsEnabled[brandId] = res.teamLiveGroupSettings.brand_settings.biometric_consent_enabled;
                    isBreakWaiverConsentReportSettingsEnabled[brandId] = res.teamLiveGroupSettings.brand_settings.break_waiver_enabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        };

        self.checkBiometricConsentReportVisibility = function (brandId) {
            return (
                isHarriClockEnabled[brandId] &&
                isTeamSchedulingEnabled[brandId] &&
                activeReports[brandId] &&
                canViewBiometricConsentReport[brandId] &&
                isBiometricConsentReportSettingsEnabled[brandId] &&
                activeReports[brandId]['BIOMETRIC_CONSENT_REPORT']
            );
        };

        self.checkBreakWaiverConsentReportVisibility = function (brandId) {
            return (
                isHarriClockEnabled[brandId] &&
                isTeamSchedulingEnabled[brandId] &&
                activeReports[brandId] &&
                canViewBreakWaiverConsentReport[brandId] &&
                isBreakWaiverConsentReportSettingsEnabled[brandId] &&
                activeReports[brandId]['BREAK_WAIVER_CONSENT_REPORT']
            );
        };

        self.checkConsentReportsVisibility = function (brandId) {
            return (
                self.checkBiometricConsentReportVisibility(brandId) ||
                self.checkBreakWaiverConsentReportVisibility(brandId)
            );
        };

        self.getUnemploymentClaimsReportPrerequisites = function (brandId) {
            const promises = {};

            promises.policyParser = userPermissions.getBrandPolicy(brandId);
            promises.activeReports = getActiveReports(brandId);

            return $q.all(promises)
                .then((res) => {
                    const policyParser = res.policyParser;

                    canViewUnemploymentClaimsReport[brandId] = policyParser.has(
                        userPermissions.PERMISSIONS.VIEW_UNEMPLOYMENT_CLAIMS_REPORT
                    );
                })
                .catch(function (err) {
                    console.error(err);
                });
        };

        self.checkUnemploymentClaimsReportVisibility = (brandId) => {
            return (
                activeReports?.[brandId]?.['UNEMPLOYMENT_CLAIMS_REPORT'] &&
                canViewUnemploymentClaimsReport[brandId]
            );
        };

        self.getAvailabilityReportPrerequisites = function (brandId) {
            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewAvailabilityReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_AVAILABILITY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkAvailabilityReportVisibility = function (brandId) {
            return (
                canViewAvailabilityReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['AVAILABILITY']
            );
        }

        self.getEmployeeRostertPrerequisites = function (brandId) {
            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewEmployeeRosterReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_ROSTER_REPORT);
                })
                .catch((err) => {
                    console.error(err);
                });
        }

        self.checkEmployeeRostertVisibility = function (brandId) {
            return (
                canViewEmployeeRosterReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['EMPLOYEE_ROSTER']
            );
        }

        self.getAbsenceTrackerPrerequisites = function (brandId) {
            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['activeReports'] = getActiveReports(brandId);
            promises['hasOtherAbsenceTypes'] = hasOtherAbsenceTypes(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewEmployeeRosterReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_ROSTER_REPORT);
                    isAbsenceTrackerReportVisible[brandId] = res['hasOtherAbsenceTypes'];
                    hasAnyAbsenceTrackerAccess[brandId] = policyParser.hasAny(absenceTrackerReportPermissions);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkAbsenceTrackerVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId] &&
                isAbsenceTrackerReportVisible[brandId] &&
                activeReports[brandId] && activeReports[brandId]['ABSENCE_TRACKER_REPORT'] &&
                hasAnyAbsenceTrackerAccess[brandId];
        }

        self.getClockInMessagePrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            if (hasActiveBrandHarriClock[brandId]) {
                promises['announcementsSettings'] = TeamInteractionsAPI.getAnnouncementsSettings(brandId);
            }

            return $q.all(promises)
                .then(function (res) {
                    if (hasActiveBrandHarriClock[brandId]) {
                        announcementsSettings[brandId] = res.announcementsSettings.announcement_settings;
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkClockInMessageVisibility = function (brandId) {
            return !!announcementsSettings[brandId] &&
                !!announcementsSettings[brandId].announcement_action &&
                activeReports[brandId] && activeReports[brandId]['CLOCK_IN_MESSAGE'];
        }

        self.getEmployeeDetailedSatisfactionPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isSatisfactionEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.EMPLOYEE_SATISFACTION_MODEL, brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isSatisfactionEnabled[brandId] = res.isSatisfactionEnabled;
                    var policyParser = res['policyParser'];
                    canViewEmployeesSatisfaction[brandId] = policyParser.categories(policyParser.ANY).has(userPermissions.PERMISSIONS.MANAGE_VIEW_SATISFACTION);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkEmployeeDetailedSatisfactionReportVisibility = function (brandId) {
            return false && isSatisfactionEnabled[brandId]  &&
                canViewEmployeesSatisfaction[brandId] &&
                isActiveBrandEnterprise[brandId] &&
                activeReports[brandId] && activeReports[brandId]['EMPLOYEE_DETAILED_SATISFACTION_REPORT'];
        }

        self.getEmployeeEditsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canAccessEditsReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.ACCESS_EMPLOYEE_EDITS_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkEmployeeEditsReportVisibility = function (brandId) {
            return canAccessEditsReport[brandId] && activeReports[brandId] && activeReports[brandId]['EMPLOYEE_EDITS_REPORT'];
        }

        self.getEmployeeHealthCheckReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isTeamQuestionnaireServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_QUESTIONING, brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isTeamQuestionnaireServiceEnabled[brandId] = res.isTeamQuestionnaireServiceEnabled;
                    var policyParser = res['policyParser'];
                    canViewEmployeeQuestionnaireReports[brandId] = policyParser.categories(policyParser.ANY).has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_QUESTIONNAIRE_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkEmployeeHealthCheckReportVisibility = function (brandId) {
            return isTeamQuestionnaireServiceEnabled[brandId] &&
                canViewEmployeeQuestionnaireReports[brandId] &&
                activeReports[brandId] && activeReports[brandId]['EMPLOYEE_HEALTH_CHECK_REPORT'];
        }

        self.getGFEDocumentTrackingPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isGFEServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.GFE_INCIDENTS_TRACKING, brandId);

            return $q.all(promises)
                .then(function (res) {
                    isGFEServiceEnabled[brandId] = res.isGFEServiceEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkGFEDocumentTrackingVisibility = function (brandId) {
            return isGFEServiceEnabled[brandId] &&
                activeReports[brandId] && activeReports[brandId]['GFE_DOCUMENTS_TRACKING_REPORT'];
        }

        self.getHealthCheckSummaryReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isTeamQuestionnaireServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.TEAM_QUESTIONING, brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isTeamQuestionnaireServiceEnabled[brandId] = res.isTeamQuestionnaireServiceEnabled;
                    var policyParser = res['policyParser'];
                    canViewEmployeeQuestionnaireReports[brandId] = policyParser.categories(policyParser.ANY).has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_QUESTIONNAIRE_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkHealthCheckSummaryReportVisibility = function (brandId) {
            return isTeamQuestionnaireServiceEnabled[brandId] &&
                canViewEmployeeQuestionnaireReports[brandId] &&
                activeReports[brandId] && activeReports[brandId]['HEALTH_CHECK_SUMMARY_REPORT'];
        }

        self.getHolidayAllowanceReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    hasManageAbsenceRequestsPermission[brandId] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_ABSENCE_REQUESTS);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkHolidayAllowanceReportVisibility = function (brandId) {
            return (isUKBrand[brandId] || isDKBrand[brandId]) &&
                activeReports[brandId] && activeReports[brandId]['HOLIDAY_ALLOWANCE_REPORT'] &&
                hasManageAbsenceRequestsPermission[brandId];
        }

        self.getTeamMemberMasterReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    hasAnyWagesAccess[brandId] = policyParser.hasAny(wagesPermissions);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkTeamMemberMasterReportVisibility = function (brandId) {
            return hasAnyWagesAccess[brandId] &&
                activeReports[brandId] && activeReports[brandId]['TEAM_MEMBERS_MASTER_REPORT'];
        }

        self.getDARPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewDailyActivityReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_DAILY_ACTIVITY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkDARVisibility = function (brandId) {
            return (
                canViewDailyActivityReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['DAILY_ACTIVITY_REPORT']
            );
        }

        self.getPayPeriodReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewPayPeriodReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_PAY_PERIOD_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkPayPeriodReportVisibility = function (brandId) {
            return (
                canViewPayPeriodReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['PAY_PERIOD_REPORT']
            );
        }

        self.getLaborAnalysisReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewLaborAnalysisReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_LABOR_ANALYSIS_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLaborAnalysisReportVisibility = function (brandId) {
            return (
                canViewLaborAnalysisReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['LABOR_ANALYSIS']
            );
        }

        self.getPunchReportsPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId, true);
            promises['isHarriClockEnabled'] = brandServices.check(brandServices.SERVICES.HARRI_CLOCK, brandId, true);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewTimePunchSummaryReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_TIME_PUNCH_REPORTS);
                    canViewFullPunchDetailReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_FULL_PUNCH_REPORTS);
                    canViewTimePunchChangeApprovalReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_PUNCH_CHANGE_APPROVAL_REPORT);
                    isTeamSchedulingEnabled[brandId] = res['isTeamSchedulingEnabled'];
                    isHarriClockEnabled[brandId] = res['isHarriClockEnabled'];
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkPunchReportsVisibility = function (brandId) {
            var hasAccessToTimePunchSummary = (
                canViewTimePunchSummaryReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['TIME_PUNCH_SUMMARY']
            );
            var hasAccessToFullPunchDetail = (
                canViewFullPunchDetailReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['FULL_PUNCH_DETAIL']
            );
            var hasAccessToTimePunchChangeApproval = (
                canViewTimePunchChangeApprovalReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['TIME_PUNCH_CHANGE_APPROVAL']
            );

            return isTeamSchedulingEnabled[brandId] && isHarriClockEnabled[brandId] && (
                hasAccessToTimePunchSummary ||
                hasAccessToFullPunchDetail ||
                hasAccessToTimePunchChangeApproval
            );
        }

        self.checkPunchSummaryReportVisibility = function (brandId) {
            const hasAccessToTimePunchSummary = (
                canViewTimePunchSummaryReport[brandId] &&
                activeReports?.[brandId]?.['TIME_PUNCH_SUMMARY']
            );

            return isTeamSchedulingEnabled[brandId] && isHarriClockEnabled[brandId] && hasAccessToTimePunchSummary;
        };

        self.getLaborExceptionReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewLaborExceptionReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_LABOR_EXCEPTION_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLaborExceptionReportVisibility = function (brandId) {
            return (
                canViewLaborExceptionReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['LABOR_EXCEPTION_REPORT']
            );
        }

        self.getApproachingWeeklyOTReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkApproachingWeeklyOTReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId] &&
                activeReports[brandId] && activeReports[brandId]['APPROACHING_WEEKLY_OT_REPORT'] &&
                hasActiveBrandHarriClock[brandId];
        }

        self.getBreaksReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canManageEmployeeTimeCards[brandId] = policyParser.categories(policyParser.ANY).hasAny(userPermissions.MANAGE_TIME_CARDS);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkBreaksReportVisibility = function (brandId) {
            return canManageEmployeeTimeCards[brandId]
                && hasActiveBrandHarriClock[brandId]
                && activeReports[brandId] && activeReports[brandId]['BREAKS_REPORT'];
        }

        self.getFWWPremiumsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isFailScheduleEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.FAIR_SCHEDULING, brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canManageHourlyEmployessWages[brandId] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES) || policyParser.has(userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES);
                    isFailScheduleEnabled[brandId] = res.isFailScheduleEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkFWWPremiumsReportVisibility = function (brandId) {
            return isFailScheduleEnabled[brandId] &&
                canManageHourlyEmployessWages[brandId] &&
                activeReports[brandId] && activeReports[brandId]['FWW_PREMIUMS_REPORT'];
        }

        self.getMissedBreaksReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkMissedBreaksReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId]
                && hasActiveBrandHarriClock[brandId]
                && activeReports[brandId] && activeReports[brandId]['MISSED_BREAKS_REPORT'];
        }

        self.getForecastAccuracyReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewForecastAccuracyReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_FORECAST_ACCURACY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkForecastAccuracyReportVisibility = function (brandId) {
            return (
                canViewForecastAccuracyReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['FORECAST_ACCURACY_REPORT']
            );
        }

        self.getPunchDetailReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessToAll[brandId] = policyParser.categories(policyParser.ALL).hasAll(appliedPermissionsForPayTypes) || policyParser.categories(policyParser.ALL).hasAll(appliedViewPermissionsForPayTypes);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkPunchDetailReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId]
                && hasActiveBrandHarriClock[brandId]
                && isAllowedAccessToAll[brandId]
                && activeReports[brandId] && activeReports[brandId]['PUNCH_DETAIL_REPORT'];
        }

        const loadTimesheetSettings = async (brandId) => {
            try {
                if (timesheetSettingsCache[brandId]) {
                    return (angular.copy(timesheetSettingsCache[brandId]));
                } else {
                    let promise;

                    if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                        promise = PerformanceAggregatorAPI.getEmployeeTimesheetSettings(brandId);
                    } else {
                        promise = GatewayTeamLiveAPI.getEmployerTimesheetSettings(brandId);
                    }

                    const settings = await promise;
                    if (settings.errors_lookups) {
                        settings.errors_lookups = _.filter(settings.errors_lookups, function (errorsLookup) {
                            return ['FAIR_WORK_WEEK_PENALTY', 'FINAL_FAIR_WORK_WEEK_PENALTY'].indexOf(errorsLookup.type) === -1;
                        });
                    }
                    timesheetSettingsCache[brandId] = settings;
                    return (angular.copy(timesheetSettingsCache[brandId]));
                }
            } catch (err) {
                console.error(err);
            }
        };

        self.getPunchPhotosExceptionsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            if (isClockTimeAppEnabled()) {
                promises['timesheetSettings'] = loadTimesheetSettings();
            }

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedToViewEmployeesPunchPhoto[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEES_PUNCH_PHOTOS);

                    if (isClockTimeAppEnabled()) {
                        clockLoginSettings[brandId] = res.timesheetSettings['clock_login_settings'];
                    }
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkPunchPhotosExceptionsReportVisibility = function (brandId) {
            return false &&
                isAllowedToViewEmployeesPunchPhoto[brandId] &&
                clockLoginSettings['enable_recognition_warnings'] &&
                activeReports[brandId] && activeReports[brandId]['PUNCH_PHOTOS_EXCEPTIONS_REPORT'];
        }

        self.getTimeCardEditsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkTimeCardEditsReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId]
                && hasActiveBrandHarriClock[brandId]
                && activeReports[brandId] && activeReports[brandId]['TIME_CARD_EDITS_REPORT'];
        }

        self.checkEngagementRatingsReportVisibility = (brandId) => {
            return (
                isTLAccessOnlyUser &&
                isHarriEngageEnabled[brandId]
            );
        };

        self.getEngagementSurveysReportPrerequisites = function (brandId) {
            const promises = {};

            promises.brandSettings = BrandAPI.getEntryBrandSettings(brandId);
            promises.policyParser = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then((res) => {
                    const policyParser = res.policyParser;
                    const brandSettings = res.brandSettings;

                    hasViewTeamEngagement[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_TEAM_ENGAGEMENT);
                    surveysEnabled[brandId] = !!brandSettings.surveys_enabled;
                })
                .catch((err) => {
                    console.error(err);
                });
        };

        self.checkEngagementSurveysReportVisibility = (brandId) => {
            return (
                isTLAccessOnlyUser &&
                isHarriEngageEnabled[brandId] &&
                hasViewTeamEngagement[brandId] &&
                surveysEnabled[brandId]
            );
        };

        self.checkEngagementNoneRatingsReportVisibility = (brandId) => {
            return (
                isTLAccessOnlyUser &&
                isHarriEngageEnabled[brandId] &&
                ['RATINGS_ONLY', 'NONE'].indexOf(anonymityMode[brandId]) > -1
            );
        };

        self.getTimeSheetReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessTimeSheet[brandId] = policyParser.hasAny(userPermissions.MANAGE_TIME_CARDS);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkTimeSheetReportVisibility = function (brandId) {
            return isAllowedAccessTimeSheet[brandId] &&
                hasActiveBrandHarriClock[brandId] &&
                activeReports[brandId] && activeReports[brandId]['TIMESHEET_REPORT'];
        }

        self.getPollEventsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['isOnboardingJourneyEnabled'] = brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandId, true);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isOnboardingJourneyEnabled[brandId] = res.isOnboardingJourneyEnabled;
                    var policyParser = res['policyParser'];
                    canViewEmployeeEngagement[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_ENGAGEMENT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkPollEventsReportVisibility = function (brandId) {
            return isOnboardingJourneyEnabled[brandId] &&
                canViewEmployeeEngagement[brandId];
        }

        self.getTurnoverReportPrerequisites = function (brandId) {
            var promises = {};
            promises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId, true);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isTeamSchedulingEnabled[brandId] = res.isTeamSchedulingEnabled;
                    var policyParser = res['policyParser'];
                    canAccessEmployeeTurnoverReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.ACCESS_EMPLOYEE_TURNOVER_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkTurnoverReportVisibility = function (brandId) {
            return isTeamSchedulingEnabled[brandId] &&
                activeReports[brandId] && activeReports[brandId]['EMPLOYEE_TURNOVER_REPORT'] &&
                canAccessEmployeeTurnoverReport[brandId];
        }

        self.getWageTypeSummaryReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessToAll[brandId] = policyParser.categories(policyParser.ALL).hasAll(appliedPermissionsForPayTypes) || policyParser.categories(policyParser.ALL).hasAll(appliedViewPermissionsForPayTypes);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkWageTypeSummaryReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId]
                && hasActiveBrandHarriClock[brandId]
                && isAllowedAccessToAll[brandId]
                && activeReports[brandId] && activeReports[brandId]['WAGE_TYPE_SUMMARY'];
        }

        self.getDailyCrewScheduleReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewDailyCrewScheduleLineBarReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_DAILY_CREW_SCHEDULE_LINE_BAR_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkDailyCrewScheduleReportVisibility = function (brandId) {
            return (
                canViewDailyCrewScheduleLineBarReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['DAILY_CREW_SCHEDULE']
            );
        }

        self.getScheduleChangeReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewScheduleChangeReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_SCHEDULE_CHANGE_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkScheduleChangeReportVisibility = function (brandId) {
            return (
                canViewScheduleChangeReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['SCHEDULE_CHANGE_REPORTING']
            );
        }

        self.getWeeklyScheduleReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewWeeklyScheduleReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_WEEKLY_SCHEDULE_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkWeeklyScheduleReportVisibility = function (brandId) {
            return (
                canViewWeeklyScheduleReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['WEEKLY_SCHEDULE_REPORT']
            );
        }

        self.getAvailableShiftsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkAvailableShiftsReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId] && activeReports[brandId] && activeReports[brandId]['AVAILABLE_SHIFTS_REPORT'];
        }

        self.getDetailedEmployeeLaborReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessTimeSheet[brandId] = policyParser.hasAny(userPermissions.MANAGE_TIME_CARDS);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkDetailedEmployeeLaborReportVisibility = function (brandId) {
            return (
                isAllowedAccessTimeSheet[brandId] &&
                activeReports[brandId] && activeReports[brandId]['DETAILED_EMPLOYEE_LABOUR_REPORT']
            );
        }

        self.getEmployeeLaborVarianceReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessToAll[brandId] = policyParser.categories(policyParser.ALL).hasAll(appliedPermissionsForPayTypes) || policyParser.categories(policyParser.ALL).hasAll(appliedViewPermissionsForPayTypes);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkEmployeeLaborVarianceReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId]
                && (hasActiveBrandPOS[brandId] || hasActiveBrandHarriClock[brandId])
                && isAllowedAccessToAll[brandId]
                && activeReports[brandId] && activeReports[brandId]['EMPLOYEE_LABOUR_VARIANCE_REPORT'];
        }

        self.getEnterpriseFlashReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    isAllowedAccessToAll[brandId] = policyParser.categories(policyParser.ALL).hasAll(appliedPermissionsForPayTypes) || policyParser.categories(policyParser.ALL).hasAll(appliedViewPermissionsForPayTypes);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkEnterpriseFlashReportVisibility = function (brandId) {
            return isEmployerAndEnterOrChildHasHarriClockOrPOS[brandId] &&
                isAllowedAccessToAll[brandId] &&
                activeReports[brandId] && activeReports[brandId]['FLASH_DASH_REPORT'];
        }

        self.getFlashReportV2Prerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canAccessFlashWageTypeSummaryReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.ACCESS_FLASH_WAGE_TYPE_SUMMARY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkFlashReportV2Visibility = function (brandId) {
            return canAccessFlashWageTypeSummaryReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['FLASH_DASH_V2'];
        }

        self.getLaborVarianceReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    hasAnyWagesAccess[brandId] = policyParser.hasAny(wagesPermissions);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLaborVarianceReportVisibility = function (brandId) {
            return hasAnyWagesAccess[brandId] &&
                activeReports[brandId] && activeReports[brandId]['LABOUR_VARIANCE_REPORT'];
        }

        self.getLogbookChecklistsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isLogbookEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, brandId);

            return $q.all(promises)
                .then(function (res) {
                    isLogbookEnabled[brandId] = res.isLogbookEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLogbookChecklistsReportVisibility = function (brandId) {
            return isLogbookEnabled[brandId] &&
                activeReports[brandId] && activeReports[brandId]['LOGBOOK_CHECKLISTS_REPORT'];
        }

        self.getLogbookEntriesReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isLogbookEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isLogbookEnabled[brandId] = res.isLogbookEnabled;
                    var policyParser = res['policyParser'];
                    canManageLogbookEntries[brandId] = policyParser.has(userPermissions.PERMISSIONS.MANAGE_ENTRIES);
                    canViewLogbookEntries[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_ENTRIES);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLogbookEntriesReportVisibility = function (brandId) {
            return isLogbookEnabled[brandId] &&
                (canManageLogbookEntries[brandId] || canViewLogbookEntries[brandId]) &&
                activeReports[brandId] && activeReports[brandId]['LOGBOOK_ENTRIES_REPORT'];
        }

        self.getLogbookTasksReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isLogbookEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.LOGBOOK, brandId);

            return $q.all(promises)
                .then(function (res) {
                    isLogbookEnabled[brandId] = res.isLogbookEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkLogbookTasksReportVisibility = function (brandId) {
            return isLogbookEnabled[brandId] &&
                activeReports[brandId] && activeReports[brandId]['LOGBOOK_TASKS_REPORT'];
        }

        self.getManagerScheduleReportPrerequisites = (brandId) => {
            const promises = {};

            promises['activeReports'] = getActiveReports(brandId);
            promises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId, true);
            promises['isStationsLevelsEnabled'] = brandServices.check(brandServices.SERVICES.JOB_TITLE_SKILL_LEVEL, brandId, true);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['scheduleSettings'] = getScheduleSettings(brandId);

            return $q.all(promises)
                .then((res) => {
                    const policyParser = res['policyParser'];
                    const scheduleViews = res['scheduleSettings']?.schedule_views || [];
                    const isManagerViewAvailable = scheduleViews.findIndex(view => view.name?.toLowerCase() === 'manager');

                    canViewManagerSchedule[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_MANAGER_SCHEDULE_REPORT);
                    isStationsLevelsEnabled[brandId] = res['isStationsLevelsEnabled']
                    isTeamSchedulingEnabled[brandId] = res['isTeamSchedulingEnabled'];
                    isScheduleManagerViewAvailable[brandId] = isManagerViewAvailable > -1;
                })
                .catch((err) => {
                    console.error(err);
                });
        }

        self.checkManagerScheduleReportVisibility = (brandId) => {
            return (
                activeReports?.[brandId]?.['MANAGER_SCHEDULE_REPORT'] &&
                canViewManagerSchedule[brandId] &&
                isStationsLevelsEnabled[brandId] &&
                isTeamSchedulingEnabled[brandId] &&
                isScheduleManagerViewAvailable[brandId]
            );
        }

        self.getNeededHoursReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['isWendysSettingsEnabled'] = getWendysLaborSettings(brandId);
            promises['isABSSettingsEnabled'] = getABSSettings(brandId);
            promises['isCarrolSettingsEnabled'] = getCarrolLaborSettings(brandId);

            return $q.all(promises)
                .then(function (res) {
                    isWendysSettingsEnabled[brandId] = res.isWendysSettingsEnabled;
                    isABSSettingsEnabled[brandId] = res.isABSSettingsEnabled;
                    isCarrolSettingsEnabled[brandId] = res.isCarrolSettingsEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkJibLaborService = (brandId) => {
            const promises = {
                isJibLaborServiceEnabled: brandServices.check(brandServices.SERVICES.JACK_IN_THE_BOX_LABOR_MODEL, brandId)
            };

            return $q.all(promises)
                .then((res) => {
                    self.isJibLaborServiceEnabled = res.isJibLaborServiceEnabled;
                })
                .catch((err) => {
                    console.error(err);
                });
        };

        self.checkNeededHoursReportVisibility = (brandId) => {
            return ((isWendysLaborServiceEnabled[brandId] && isWendysSettingsEnabled[brandId]) ||
                    (isABSServiceEnabled[brandId] && isABSSettingsEnabled[brandId]) ||
                    (isCarrolLaborServiceEnabled[brandId] && isCarrolSettingsEnabled[brandId]) ||
                    self.isJibLaborServiceEnabled
                )
                && activeReports[brandId]?.['NEEDED_HOURS_REPORT'];
        };

        self.getScheduleAuditReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    hasManageOrPublishSchedulePermissions[brandId] = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_SCHEDULE, userPermissions.PERMISSIONS.PUBLISH_SCHEDULE]);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkScheduleAuditReportVisibility = function (brandId) {
            return hasManageOrPublishSchedulePermissions[brandId] &&
                activeReports[brandId] && activeReports[brandId]['SCHEDULE_AUDIT_REPORT'];
        }

        self.getScheduleStatusReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);

            return $q.all(promises)
                .then(function (res) {
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkScheduleStatusReportVisibility = function (brandId) {
            return activeReports[brandId]?.['SCHEDULING_STATUS_REPORT'];
        }

        self.getUnscheduledEmployeeReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canAccessUnscheduledEmployeeReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_UN_SCHEDULED_EMPLOYEE_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkUnscheduledEmployeeReportVisibility = function (brandId) {
            return canAccessUnscheduledEmployeeReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['UNSCHEDULED_EMPLOYEE_REPORT'];
        }

        self.getMetricsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, brandId, true);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewScheduleCreationMetricReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_SCHEDULE_CREATION_METRICS_REPORT);
                    isTeamSchedulingEnabled[brandId] = res['isTeamSchedulingEnabled'];
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkMetricsReportVisibility = function (brandId) {
            return isTeamSchedulingEnabled[brandId] &&
                activeReports[brandId] && activeReports[brandId]['SCHEDULE_CREATION_METRICS_REPORT'] &&
                canViewScheduleCreationMetricReport[brandId];
        }

        self.getRegularScheduleVariationsReportPrerequisites = function (brandId) {
            var defer = $q.defer();
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['considerRegularScheduleVariationSettings'] = getGFETemplateSettings(brandId);

            $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    hasManageOrPublishSchedulePermissions[brandId] = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_SCHEDULE, userPermissions.PERMISSIONS.PUBLISH_SCHEDULE]);
                    isConsiderRegularScheduleVariationSettingsEnabled[brandId] = res.considerRegularScheduleVariationSettings?.settings?.is_variations_enabled;

                    getGFEScheduleOnAnyChild(brandId)
                        .then(function(resVariationSettingEnabledOnOneOrMoreChild) {
                            isVariationSettingEnabledOnOneOrMoreChild[brandId] = resVariationSettingEnabledOnOneOrMoreChild;
                            defer.resolve(true);
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject(false);
                        });
                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(false);
                });
            return defer.promise;
        }

        self.checkRegularScheduleVariationsReportVisibility = function (brandId) {
            return isConsiderRegularScheduleVariationSettingsEnabled[brandId] &&
                isVariationSettingEnabledOnOneOrMoreChild[brandId] &&
                hasManageOrPublishSchedulePermissions[brandId] &&
                activeReports[brandId] && activeReports[brandId]['REGULAR_SCHEDULE_VARIATION_REPORT'];
        }

        self.getIntegrationRejectionReportsPrerequisites = function (brandId) {
            const defer = $q.defer();
            const promises = {};

            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isDataPassSyncEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DATA_PASS_SYNC, brandId);

            $q.all(promises)
                .then(function (res) {
                    const policyParser = res['policyParser'];

                    canViewMcHireIntegrationRejectionReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_MCHIRE_INTEGRATION_REJECTION_REPORT);
                    canViewFredIntegrationRejectionReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_FRED_INTEGRATION_REJECTION_REPORT);
                    isDataPassSyncEnabled[brandId] = res.isDataPassSyncEnabled;

                    getPostHireServiceSettings(brandId)
                        .then(function (settings) {
                            isMcHireCreationFlowEnabled[brandId] = !!settings?.is_mc_hire_creation_flow_enabled;
                            isSkillLevelSyncEnabled[brandId] = !!settings?.sync_job_title;
                            defer.resolve(true);
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.reject(false);
                        });

                })
                .catch(function (err) {
                    console.error(err);
                    defer.reject(false);
                });
            return defer.promise;
        }

        self.checkMcHireIntegrationRejectionReportVisibility = function (brandId) {
            return (
                canViewMcHireIntegrationRejectionReport[brandId] &&
                activeReports[brandId] &&
                activeReports[brandId]['MCHIRE_INTEGRATION_REJECTION'] &&
                isMcHireCreationFlowEnabled[brandId]
            );
        }

        self.checkAdpEmployeeSyncReportVisibility = (brandId) => {
            return activeReports[brandId]?.['ADP_EMPLOYEE_SYNC_STATUS_REPORT'] && canViewAdpEmployeeSyncReport[brandId];
        };

        self.checkFredIntegrationRejectionReportVisibility = (brandId) => {
            return (
                activeReports[brandId] &&
                activeReports[brandId]['FRED_INTEGRATION_REJECTION'] &&
                canViewFredIntegrationRejectionReport[brandId] &&
                isSkillLevelSyncEnabled[brandId]
            );
        };

        self.checkIntegrationRejectionReportsVisibility = (brandId) => {
            return (
                self.checkMcHireIntegrationRejectionReportVisibility(brandId) ||
                self.checkFredIntegrationRejectionReportVisibility(brandId)
            );
        };

        self.getNoPayReportPrerequisites = function (brandId) {
            var promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewNoPayReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_NO_PAY_REPORT);
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.getAdpEmployeeSyncReportPrerequisites = (brandId) => {
            const promises = {};
            promises['activeReports'] = getActiveReports(brandId);
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);

            return $q.all(promises)
                .then((res) => {
                    const policyParser = res['policyParser'];
                    canViewAdpEmployeeSyncReport[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_ADP_EMPLOYEE_SYNC_STATUS_REPORT);
                })
                .catch((err) => {
                    console.error(err);
                });
        }

        self.checkNoPayReportVisibility = function (brandId) {
            return (
                canViewNoPayReport[brandId] &&
                activeReports[brandId] && activeReports[brandId]['NO_PAY_REPORT']
            );
        }

        self.getOnboardingJourneyEventsReportPrerequisites = function (brandId) {
            var promises = {};
            promises['policyParser'] = userPermissions.getBrandPolicy(brandId);
            promises['isOnboardingJourneyEnabled'] = brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandId, true);

            return $q.all(promises)
                .then(function (res) {
                    var policyParser = res['policyParser'];
                    canViewEmployeeEngagement[brandId] = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEE_ENGAGEMENT);
                    isOnboardingJourneyEnabled[brandId] = res.isOnboardingJourneyEnabled;
                })
                .catch(function (err) {
                    console.error(err);
                });
        }

        self.checkOnboardingJourneyEventsReportVisibility = function (brandId) {
            return (
                isOnboardingJourneyEnabled[brandId] &&
                canViewEmployeeEngagement[brandId]
            );
        }

        const getHarriEngageReportsPrerequisites = (brandId) => {
            return brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, hUser.getUserContext().brand_id, true)
                .then((res) => {
                    isHarriEngageEnabled[brandId] = res;
                })
                .catch(console.error);
        };

        var checkActiveReportRequests = {};
        var getActiveReports = function (brandId) {
            var defer = $q.defer();
            var actReports = {};
            if (checkActiveReportRequests[brandId]) {
                return checkActiveReportRequests[brandId];
            }
            checkActiveReportRequests[brandId] = defer.promise;

            if (activeReports[brandId]) {
                defer.resolve(activeReports[brandId]);
            } else {
                userServices.isServiceEnabled(userServices.SERVICES.CUSTOM_REPORTS, brandId)
                    .then(function (resCustomReportsServiceEnabled) {
                        isCustomReportsServiceEnabled = resCustomReportsServiceEnabled;
                        if (isCustomReportsServiceEnabled) {
                            ReportingManagementAPI.getReportsServiceSettings(brandId)
                                .then(function (reportsServiceSettings) {
                                    activeReportsSettings[brandId] = reportsServiceSettings.reports;
                                    for (var i in reportsServiceSettings.reports) {
                                        var reportCode = reportsServiceSettings.reports[i].code;
                                        actReports[reportCode] = true;
                                    }
                                    activeReports[brandId] = actReports;
                                    defer.resolve(actReports);
                                })
                                .catch(function (error) {
                                    console.error(error);
                                    defer.reject(actReports);
                                })
                                .finally(function () {
                                    delete checkActiveReportRequests[brandId];
                                });
                        } else {
                            activeReports[brandId] = actReports;
                            defer.resolve(actReports);
                        }
                    })
                    .catch(function (error) {
                        console.error(error);
                        defer.reject(actReports);
                    });
            }

            return defer.promise;
        };

        const getGFETemplateSettings = async (brandId) => {
            try {
                if (gfeTemplateSettingsCache[brandId]) {
                    return gfeTemplateSettingsCache[brandId];
                } else {
                    const gfeTemplateSettings = await GoodFaithEstimateAPI.getGFETemplateSettings(brandId);
                    gfeTemplateSettingsCache[brandId] = gfeTemplateSettings;
                    return gfeTemplateSettingsCache[brandId];
                }
            } catch (err) {
                console.error(err);
            }
        };

        var teamLiveGroupSettingsRequests = {};
        var getTeamLiveGroupSettings = function (brandId) {
            var defer = $q.defer();
            if (teamLiveGroupSettingsRequests[brandId]) {
                return teamLiveGroupSettingsRequests[brandId];
            }
            teamLiveGroupSettingsRequests[brandId] = defer.promise;

            if (teamLiveGroupSettings[brandId]) {
                defer.resolve(teamLiveGroupSettings[brandId]);
            } else {
                TeamLiveReportsAPI.getTeamLiveGroupSettings(brandId)
                    .then(function (res) {
                        teamLiveGroupSettings[brandId] = res;
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    })
                    .finally(function () {
                        delete teamLiveGroupSettingsRequests[brandId];
                    });
            }
            return defer.promise;
        };

        const scheduleSettingsRequests = {};
        const getScheduleSettings = (brandId) => {
            const defer = $q.defer();

            if (scheduleSettingsRequests[brandId]) {
                return scheduleSettingsRequests[brandId];
            }

            scheduleSettingsRequests[brandId] = defer.promise;

            if (scheduleSettings[brandId]) {
                defer.resolve(scheduleSettings[brandId]);
            } else {
                TeamScheduleAPI.getScheduleSettings(brandId)
                    .then((res) => {
                        scheduleSettings[brandId] = res;
                        defer.resolve(res);
                    })
                    .catch((err) => {
                        console.error(err);
                        defer.reject(err);
                    })
                    .finally(() => {
                        delete scheduleSettingsRequests[brandId];
                    });
            }
            return defer.promise;
        }

        var checkWendysLaborSettingsRequests = {};
        var getWendysLaborSettings = function (brandId) {
            var defer = $q.defer();
            if (checkWendysLaborSettingsRequests[brandId]) {
                return checkWendysLaborSettingsRequests[brandId];
            }
            checkWendysLaborSettingsRequests[brandId] = defer.promise;

            if (wendysLaborSettings[brandId]) {
                defer.resolve(wendysLaborSettings[brandId]);
            } else {
                userServices.isServiceEnabled(userServices.SERVICES.WENDYS_LABOR_MODEL, brandId)
                    .then(function (resWendysLaborServiceEnabled) {
                        isWendysLaborServiceEnabled[brandId] = resWendysLaborServiceEnabled;
                        if (isWendysLaborServiceEnabled[brandId]) {
                            WendysLaborAPI.getSettings(brandId)
                                .then(function (res) {
                                wendysLaborSettings[brandId] = res.settings.needed_hours_generation_enabled;
                                    defer.resolve(res.settings.needed_hours_generation_enabled);
                                })
                                .catch(function (err) {
                                    console.error(err);
                                    defer.reject(err);
                                })
                                .finally(function () {
                                    delete checkWendysLaborSettingsRequests[brandId];
                                });
                        } else {
                            defer.resolve(false);
                            delete checkWendysLaborSettingsRequests[brandId];
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    })
            }
            return defer.promise;
        }

        var checkABSSettingsRequests = {};
        var getABSSettings = function (brandId) {
            var defer = $q.defer();
            if (checkABSSettingsRequests[brandId]) {
                return checkABSSettingsRequests[brandId];
            }
            checkABSSettingsRequests[brandId] = defer.promise;

            if (ABSSettings[brandId]) {
                defer.resolve(ABSSettings[brandId].needed_hours_generation_enabled);
            } else {
                userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brandId)
                    .then(function (resABSServiceEnabled) {
                        isABSServiceEnabled[brandId] = resABSServiceEnabled;
                        if (isABSServiceEnabled[brandId]) {
                            ActivityBasedSchedulingAPI.getABSBrandSettings(brandId)
                                .then(function (res) {
                                    ABSSettings[brandId] = res;
                                    defer.resolve(res.needed_hours_generation_enabled);
                                })
                                .catch(function (err) {
                                    console.error(err);
                                    defer.reject(err);
                                })
                                .finally(function () {
                                    delete checkABSSettingsRequests[brandId];
                                });
                        } else {
                            defer.resolve(false);
                            delete checkABSSettingsRequests[brandId];
                        }
                    })
                    .catch(function (err) {
                        console.error(err);
                        defer.reject(err);
                    })
            }

            return defer.promise;
        }

        var checkCarrolLaborSettingsRequests = {};
        var getCarrolLaborSettings = function (brandId) {
            var defer = $q.defer();
            if (checkCarrolLaborSettingsRequests[brandId]) {
                return checkCarrolLaborSettingsRequests[brandId];
            }
            checkCarrolLaborSettingsRequests[brandId] = defer.promise;

            if (carrolLaborSettings[brandId]) {
                defer.resolve(carrolLaborSettings[brandId].needed_hours_generation_enabled);
            } else {
                userServices.isServiceEnabled(userServices.SERVICES.CARROL_LABOR_MODEL, brandId)
                    .then(function (resCarrolLaborServiceEnabled) {
                        isCarrolLaborServiceEnabled[brandId] = resCarrolLaborServiceEnabled;
                        if (isCarrolLaborServiceEnabled[brandId]) {
                            CarrolLaborAPI.getCarrolLaborBrandSettings(brandId)
                                .then(function (res) {
                                    carrolLaborSettings[brandId] = res;
                                    defer.resolve(res.needed_hours_generation_enabled);
                                })
                                .finally(function () {
                                    delete checkCarrolLaborSettingsRequests[brandId];
                                });
                        } else {
                            defer.resolve(false);
                            delete checkCarrolLaborSettingsRequests[brandId];
                        }
                    })
            }
            return defer.promise;
        }

        var checkGFEScheduleOnAnyChildRequests = {};
        var getGFEScheduleOnAnyChild = function (brandId) {
            var defer = $q.defer();
            if (checkGFEScheduleOnAnyChildRequests[brandId]) {
                return checkGFEScheduleOnAnyChildRequests[brandId];
            }
            checkGFEScheduleOnAnyChildRequests[brandId] = defer.promise;

            if (isGFEScheduleOnAnyChild[brandId] && typeof isGFEScheduleOnAnyChild[brandId] === 'boolean' ) {
                defer.resolve(isGFEScheduleOnAnyChild[brandId])
            } else {
                if (isConsiderRegularScheduleVariationSettingsEnabled) {
                    OnBoardingAPI.getGFEAnticipatedBrands(brandId, 'GOOD_FAITH_ESTIMATE_SCHEDULE_LITE')
                        .then(function (res) {
                            if (res.brands.length) {
                                isGFEScheduleOnAnyChild[brandId] = true;
                                defer.resolve(true);
                                return;
                            } else {
                                isGFEScheduleOnAnyChild[brandId] = false;
                                defer.resolve(false);
                            }
                        })
                        .finally(function () {
                            delete checkGFEScheduleOnAnyChildRequests[brandId];
                        });
                } else {
                    isGFEScheduleOnAnyChild[brandId] = false;
                    defer.resolve(false);
                }
            }
            return defer.promise
        }

        var checkPostHireServiceSettingsRequests = {};
        var getPostHireServiceSettings = function (brandId) {
            const defer = $q.defer();

            if (checkPostHireServiceSettingsRequests[brandId]) {
                return checkPostHireServiceSettingsRequests[brandId];
            }

            checkPostHireServiceSettingsRequests[brandId] = defer.promise;

            if (postHireServiceSettings[brandId]) {
                defer.resolve(postHireServiceSettings[brandId]);
            } else {
                if (isDataPassSyncEnabled[brandId]) {
                    DataPassAPI.getPostHireService([brandId])
                        .then(function (brands) {
                            for (let i in brands) {
                                const brand = brands[i];

                                if (brand.id === brandId) {
                                    for (let j in brand.brand_services) {
                                        const service = brand.brand_services[j];

                                        if (service.code === 'DATAPASS') {
                                            postHireServiceSettings[brandId] = service;
                                            break;
                                        }
                                    }

                                    break;
                                }
                            }

                            defer.resolve(postHireServiceSettings[brandId]);
                        })
                        .catch(function (err) {
                            console.error(err)
                        })
                        .finally(function () {
                            delete checkPostHireServiceSettingsRequests[brandId];
                        });
                } else {
                    postHireServiceSettings[brandId] = false;
                    defer.resolve(false);
                }
            }
            return defer.promise;
        }

        var absenceTrackerRequests = {};
        var hasOtherAbsenceTypes = function (brandId) {
            var defer = $q.defer();
            if (absenceTrackerRequests[brandId]) {
                return absenceTrackerRequests[brandId];
            }
            absenceTrackerRequests[brandId] = defer.promise;

            if (hasOtherAbsenceTypesCached[brandId] && typeof hasOtherAbsenceTypesCached[brandId] === 'boolean') {
                defer.resolve(hasOtherAbsenceTypesCached[brandId])
            } else {
                AttendanceAPI.getAbsenceTypes(brandId)
                    .then(function (absenceTypes) {
                        if (absenceTypes && absenceTypes.length) {
                            for (var i in absenceTypes) {
                                if (['CUSTOM', 'PATERNITY', 'BEREAVEMENT', 'MATERNITY', 'SHARED_PARENTAL', 'ADOPTION', 'HOLIDAY', 'LOA', 'TIME_OFF'].indexOf(absenceTypes[i].type) > -1) {
                                    hasOtherAbsenceTypesCached[brandId] = true;
                                    defer.resolve(true);
                                    return;
                                }
                            }
                        }
                        hasOtherAbsenceTypesCached[brandId] = false;
                        defer.resolve(false);
                    })
                    .catch(function (error) {
                        console.error(error);
                        defer.reject(err);
                    })
                    .finally(function () {
                        delete absenceTrackerRequests[brandId];
                    });
            }
            return defer.promise;
        };


        var initShowReport = function (activeBrand, childernHaveLPM_ClOCK) {
            isEmployerAndEnterOrChildHasHarriClockOrPOS[activeBrand.id] = ((activeBrand.type === 'ENTERPRISE' && childernHaveLPM_ClOCK.length) ||
                    activeBrand.services.indexOf('POS') > -1 ||
                    activeBrand.services.indexOf('HARRI_CLOCK') > -1) &&
                isEmployer;
        };

        var getChildrenHaveLPM_ClOCK = function (brands) {
            var childrenHaveLPM_ClOCK = [];
            for (var i in brands) {
                var brand = brands[i];
                if (brand.services && (brand.services.indexOf('POS') > -1 || brand.services.indexOf('HARRI_CLOCK') > -1)) {
                    childrenHaveLPM_ClOCK.push(brand);
                }
            }
            return childrenHaveLPM_ClOCK;
        }

        var hrReportsChecks = [
            {
                check: self.checkAbsenceTrackerVisibility,
                path: 'appLayout.schedule.reports.absence-tracker-report'
            },
            {
                check: self.checkAttendanceReliabilityVisibility,
                path: 'appLayout.schedule.reports.attendance-reliability-report'
            },
            {
                check: self.checkUnemploymentClaimsReportVisibility,
                path: 'appLayout.schedule.reports.unemployment-claims-report'
            },
            {
                check: self.checkAvailabilityReportVisibility,
                path: 'appLayout.schedule.reports.availability'
            },
            {
                check: self.checkConsentReportsVisibility,
                path: 'appLayout.schedule.reports.consent-report'
            },
            {
                check: self.checkClockInMessageVisibility,
                path: 'appLayout.schedule.reports.clock-in-message-report'
            },
            {
                check: self.checkEmployeeDetailedSatisfactionReportVisibility,
                path: 'appLayout.schedule.reports.employee-detailed-satisfaction-report'
            },
            {
                check: self.checkEmployeeEditsReportVisibility,
                path: 'appLayout.schedule.reports.employee-edits-report'
            },
            {
                check: self.checkEmployeeHealthCheckReportVisibility,
                path: 'appLayout.schedule.reports.covid-19-employees-report'
            },
            {
                check: self.checkHealthCheckSummaryReportVisibility,
                path: 'appLayout.schedule.reports.employee-health-check-report'
            },
            {
                check: self.checkEmployeeRostertVisibility,
                path: 'appLayout.schedule.reports.employee-roster'
            },
            {
                check: self.checkGFEDocumentTrackingVisibility,
                path: 'appLayout.schedule.reports.gfe-documents-tracking-report'
            },
            {
                check: self.checkHolidayAllowanceReportVisibility,
                path: 'appLayout.schedule.reports.holiday-allowance'
            },
            {
                check: self.checkTurnoverReportVisibility,
                path: 'appLayout.schedule.reports.turnover-report'
            },
            {
                check: self.checkTeamMemberMasterReportVisibility,
                path: 'appLayout.schedule.reports.team-member-master-report'
            },
        ];
        var timeKeepingReports = [
            {
                check: self.checkApproachingWeeklyOTReportVisibility,
                path: 'appLayout.schedule.reports.overtime-report'
            },
            {
                check: self.checkBreaksReportVisibility,
                path: 'appLayout.schedule.reports.scheduled-breaks-report'
            },
            {
                check: self.checkDARVisibility,
                path: 'appLayout.schedule.reports.daily-activity-report'
            },
            {
                check: self.checkForecastAccuracyReportVisibility,
                path: 'appLayout.schedule.reports.forecast-accuracy-report'
            },
            {
                check: self.checkFWWPremiumsReportVisibility,
                path: 'appLayout.schedule.reports.premium-report'
            },
            {
                check: self.checkLaborAnalysisReportVisibility,
                path: 'appLayout.schedule.reports.labor-analysis-report'
            },
            {
                check: self.checkLaborExceptionReportVisibility,
                path: 'appLayout.schedule.reports.labor-exception-report'
            },
            {
                check: self.checkMissedBreaksReportVisibility,
                path: 'appLayout.schedule.reports.missed-breaks'
            },
            {
                check: self.checkNoPayReportVisibility,
                path: 'appLayout.schedule.reports.no-pay-report'
            },
            {
                check: self.checkPunchReportsVisibility,
                path: 'appLayout.schedule.reports.punch-reports'
            },
            {
                check: self.checkPayPeriodReportVisibility,
                path: 'appLayout.schedule.reports.pay-period-report'
            },
            {
                check: self.checkPunchDetailReportVisibility,
                path: 'appLayout.schedule.reports.punch-detail-report'
            },
            {
                check: self.checkTimeCardEditsReportVisibility,
                path: 'appLayout.schedule.reports.time-card-edits-report'
            },
            {
                check: self.checkTimeSheetReportVisibility,
                path: 'appLayout.schedule.reports.time-sheet-report'
            },
            {
                check: self.checkWageTypeSummaryReportVisibility,
                path: 'appLayout.schedule.reports.wage-type-summary-report'
            },
        ];
        var schedulingReports = [
            {
                check: self.checkAvailableShiftsReportVisibility,
                path: 'appLayout.schedule.reports.available-shifts'
            },
            {
                check: self.checkDailyCrewScheduleReportVisibility,
                path: 'appLayout.schedule.reports.daily-crew-schedule-report'
            },
            {
                check: self.checkDetailedEmployeeLaborReportVisibility,
                path: 'appLayout.schedule.reports.detailed-employee-labor-report'
            },
            {
                check: self.checkEmployeeLaborVarianceReportVisibility,
                path: 'appLayout.schedule.reports.employee-labor-variance-report'
            },
            {
                check: self.checkEnterpriseFlashReportVisibility,
                path: 'appLayout.schedule.reports.enterprise-flash-report'
            },
            {
                check: self.checkFlashReportV2Visibility,
                path: 'appLayout.schedule.reports.flash-report-v2'
            },
            {
                check: self.checkLaborVarianceReportVisibility,
                path: 'appLayout.schedule.reports.labor-variance-report'
            },
            {
                check: self.checkLogbookChecklistsReportVisibility,
                path: 'appLayout.schedule.reports.logbook-checklists-report'
            },
            {
                check: self.checkLogbookEntriesReportVisibility,
                path: 'appLayout.schedule.reports.logbook-entries-report'
            },
            {
                check: self.checkLogbookTasksReportVisibility,
                path: 'appLayout.schedule.reports.logbook-tasks-report'
            },
            {
                check: self.checkManagerScheduleReportVisibility,
                path: 'appLayout.schedule.reports.manager-schedule-report'
            },
            {
                check: self.checkNeededHoursReportVisibility,
                path: 'appLayout.schedule.reports.needed-hours-report'
            },
            {
                check: self.checkRegularScheduleVariationsReportVisibility,
                path: 'appLayout.schedule.reports.regular-schedule-variation-report'
            },
            {
                check: self.checkMetricsReportVisibility,
                path: 'appLayout.schedule.reports.schedule-creation-metric'
            },
            {
                check: self.checkScheduleStatusReportVisibility,
                path: 'appLayout.schedule.reports.scheduling-status'
            },
            {
                check: self.checkScheduleAuditReportVisibility,
                path: 'appLayout.schedule.reports.schedule-audit-report'
            },
            {
                check: self.checkScheduleChangeReportVisibility,
                path: 'appLayout.schedule.reports.schedule-change-report'
            },
            {
                check: self.checkUnscheduledEmployeeReportVisibility,
                path: 'appLayout.schedule.reports.unscheduled-employee-report'
            },
            {
                check: self.checkWeeklyScheduleReportVisibility,
                path: 'appLayout.schedule.reports.weekly-schedule-report'
            },
        ];
        var integrationReports = [
            {
                check: self.checkIntegrationRejectionReportsVisibility,
                path: 'appLayout.schedule.reports.integration-rejection-report'
            },
            {
                check: self.checkAdpEmployeeSyncReportVisibility,
                path: 'appLayout.schedule.reports.adp-employee-sync-status-report'
            }
        ];
        var onboardingReports = [
            {
                check: self.checkOnboardingJourneyEventsReportVisibility,
                path: 'appLayout.schedule.reports.engagement-non-ratings-report'
            },
            {
                check: self.checkPollEventsReportVisibility,
                path: 'appLayout.schedule.reports.engagement-ratings-report'
            },
        ];
    }
})();
